const config = {
  webUrl: process.env.REACT_APP_WEB_URL || (typeof window !== 'undefined' ? window.location.host : 'localhost:8001'),
  // Prefer same-origin so ALB / docker can serve API + SPA together
  domain: process.env.REACT_APP_DOMAIN || (typeof window !== 'undefined' ? window.location.origin : '')
}

module.exports = config
